import React, { lazy, useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';
import { postCheckToken, setDefaultHeader } from './core/api/Api';
import { deleteCookie, getCookie } from './core/common-service/CommonService';
import { RouteContext } from './core/context/RouteContext';
import { StoreContext } from './core/context/StoreContext';
import ProtectedRoutes from './core/routes/protected-routes/ProtectedRoutes';
import ViewContainer from './core/routes/view-container/ViewContainer';

const NotFound = lazy(() => import('./component/not-found/NotFound'));

const GlobalLoader = () => (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#fff',
      zIndex: 9999,
    }}
  >
    <div className="text-center">
      <div
        className="spinner-border text-dark mb-3"
        role="status"
        style={{ width: '3rem', height: '3rem' }}
      >
        <span className="visually-hidden">Loading...</span>
      </div>
      <p className="text-muted small">Loading...</p>
    </div>
  </div>
);

const App = () => {
  const { setIsLoggedIn, setUser } = useContext(StoreContext);
  const [isCheckingAuth, setIsCheckingAuth] = useState(
    Boolean(sessionStorage.getItem('token') || getCookie('token')),
  );

  const { paths } = useContext(RouteContext);

  useEffect(() => {
    const token = sessionStorage.getItem('token') || getCookie('token');
    if (token) {
      setDefaultHeader(token);
      postCheckToken()
        .then((res) => {
          const response = res.data;
          if (response?.success) {
            const user = response?.success?.user;
            if (user) {
              setIsLoggedIn(true);
              setUser(user);
            }
          } else {
            setIsLoggedIn(false);
            sessionStorage.clear();
            deleteCookie('token');
          }
        })
        .catch(() => {
          setIsLoggedIn(false);
          sessionStorage.clear();
          deleteCookie('token');
        })
        .finally(() => {
          setIsCheckingAuth(false);
        });
    } else {
      setIsLoggedIn(false);
      setIsCheckingAuth(false);
    }
  }, [setIsLoggedIn, setUser]);

  if (isCheckingAuth) {
    return <GlobalLoader />;
  }

  return (
    <ViewContainer>
      <Toaster
        position="top-right"
        toastOptions={{ duration: 4000, style: { fontSize: '14px' } }}
      />
      <Routes>
        {paths.map((item, index) =>
          item.path.map((el) => (
            <Route
              key={index}
              path={el + item.params.join('')}
              element={
                item.protected ? (
                  <ProtectedRoutes>{item.component}</ProtectedRoutes>
                ) : (
                  item.component
                )
              }
            />
          )),
        )}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ViewContainer>
  );
};

export default App;
